import clsx from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Button from '../../atoms/button/Button';
import GeoIpSelector from '../../atoms/geoIpSelector';
import { useGeoIpSelector } from '../../atoms/geoIpSelector/useGeoIpSelector';
import { getSelectHostName } from '../../../utils/getSelectHostName';
import { CloseCross } from '../../atoms/icons';
import { Text } from '../../typography/text/Text';
import styles from './GeoIP.module.scss';
import useGeoIpBanner from './useGeoIpBanner';

const GeoIP = ({
  message = 'Please select your country to shop online and see products that are available in your country.',
  titleButton = 'Continue'
}) => {
  const { locale_mapping, defaultCountry } = useSelector(
    (state) => state.app.context?.project?.data,
  );
  const { closeModal, isRender } = useGeoIpBanner();
  const { selectedItem } = useGeoIpSelector();
  const [localItem, setLocalItem] = useState();

  const onSubmit = (val) => {
    const item = localItem ?? val;
    const country = locale_mapping.find((c) => c.value === item);
    if (country) {
      closeModal();
      if (defaultCountry.value !== country.value) {
        window.location.assign(
          `https://${getSelectHostName(country.locale, locale_mapping)}`,
        );
      }
    }
  };

  return (
    <div
      id="geoBanner"
      className={clsx(styles.GeoIPWrapper, {
        [styles.GeoIPWrapperShown]: isRender,
      })}
    >
      <div className={styles.GeoIPInfoContainer}>
        <div className={styles.GeoIPInfoText}>
          <Text as="span">{message}</Text>
        </div>
        <div className={styles.GeoIPControls}>
          <div className={styles.GeoIPSelect}>
            <GeoIpSelector bordered isInverted setLocalItem={setLocalItem} />
          </div>
          <div className={styles.GeoIPButton}>
            <Button
              as="button"
              variant="secondary"
              isInverted
              ariaLabel={`button_${titleButton}`}
              onClick={() => {
                onSubmit(selectedItem);
              }}
            >
              <Text as="span" className={styles.GeoIPNowrap} size="xs">
                {titleButton}
              </Text>
            </Button>
          </div>
        </div>
      </div>
      <div className={styles.GeoIPIconWrap} onClick={closeModal}>
        <CloseCross width="16" height="16" className={styles.GeoIPCloseIcon} />
      </div>
    </div>
  );
};

export default GeoIP;
